window.clientBridge = new XBridge({});
import {getToken, setToken, removeToken} from "./token";
import store from './store'  //使用vuex状态管理
import { isInNewJsBridgeApp, isInAppB, isInAppC } from './index';
import axDsbridge from '@anxin/dsbridge';
import { jsbNameObj } from './dsbridgeName.js';

if (isInNewJsBridgeApp()) {
  window.clientBridge = {
    callBridge: (options) => {
      const { name, params, successCallback, failCallback } = options;
      const isAxApp = Boolean(
        window._cjDsBridge ||
          window._cjDswk ||
          navigator.userAgent.indexOf("_cjDsBridge") != -1
      );
      // 如果在含有新版的Dsbridge的App里，则使用新的方法
      if (isAxApp) {
        const axNewName = jsbNameObj[name] || name;
        // 在新改版的 dsbridge 版本中，非新增的（原老方法[axNewName !== name]），B/C端不能调用非自己端的方法
        if (axNewName !== name && isInAppB() && name.indexOf('CloudWorkbenchJsApi.setDocTitle') === -1 && name.indexOf('CloudWorkbenchJsApi') === -1) {
          console.log(name + " fail:在 B 端调用 C 端方法");
          failCallback && failCallback();
          return
        }
        if (axNewName !== name && isInAppC() && name.indexOf('CloudWorkbenchJsApi.setDocTitle') === -1 && name.indexOf('CloudWorkbenchJsApi') > -1) {
          console.log(name + " fail:在 C 端调用 B 端方法");
          failCallback && failCallback();
          return
        }
        axDsbridge.call(axNewName, params || {}, res => {
          if (res.status === 1) {
            console.log(axNewName + " success", res);
            successCallback && successCallback(res.data);
          } else {
            console.log(axNewName + " fail:", res);
            failCallback && failCallback(res);
          }
        });
      } else {
        console.log(axNewName + " fail: it's not in App");
        failCallback && failCallback();
      }
    }
  }
}


export default {
  install: function (Vue) {
    Vue.prototype.isApp = function (successHandle, failureHandle) {
      clientBridge.callBridge(
        {
          desc: "判断是否在app里",
          name: "isApp",
          params: null,
          successCallback: (res) => {
            if (res) {
              window.isApp = true
              successHandle && successHandle(res);

            }else{
              failureHandle && failureHandle();
            }
          },
          failCallback: () => {
            failureHandle && failureHandle();
          }
        }
      );
    };

    /**
     * 检测用户是否登录
     * @param loginHandle   登录时的回调
     */
    Vue.prototype.checkLogin = function (successHandle, failureHandle) {
      clientBridge.callBridge(
        {
          desc: "判断用户是否已经登录",
          name: "getTokenAndMerchantNo",
          params: null,
          successCallback: (isLogin) => {
            if (isLogin.token) {
              setToken(isLogin.token);
              store.commit('SET_LOG_IN_STATIC', true);
              localStorage.setItem('merchantNo', isLogin.merchantNo);
              store.commit('SET_MERCHANT_NO', isLogin.merchantNo)
              successHandle && successHandle();
            }else{
              failureHandle && failureHandle();
            }
          },
          failCallback: () => {
            failureHandle && failureHandle();
          }
        }
      );
    };
    /**
     *退出登录
     */
    Vue.prototype.loginOut = function (successHandle, failureHandle) {
      clientBridge.callBridge({
        name: 'loginOut',
        params: null,
        successCallback: function () {
          store.commit('SET_LOG_IN_STATIC', false)
          removeToken();
          location.reload();
          localStorage.clear();
          sessionStorage.clear();
          successHandle && successHandle();
        },
        failCallback: () => {
          failureHandle && failureHandle();
        }
      })
    };
    /**
     *更新merchantNo
     */
    Vue.prototype.setMerchantNoFromH5 = function (merchantNo) {
      clientBridge.callBridge({
        name: 'switchMerchant',
        params: merchantNo,
        successCallback: function () {
        },
        failCallback: function () {
        }
      });
    };
    /**
     *获取版本号
     */
    Vue.prototype.getClientVersion = function (successHandle, failureHandle) {
      clientBridge.callBridge({
        name: 'getAppVersion',
        params: {},
        successCallback: function (res) {
          successHandle && successHandle(+res.version.replace(/\./g, ""), res.version);
          localStorage.setItem('AppVersion', res.version);
        },
        failCallback: function () {
          failureHandle && failureHandle();
        }
      });
    };

    /**
     * 新建WebView 打开页面
     * @param urlStr
     */
    Vue.prototype.openNewWebView = function (urlStr) {
      var tempUrl = "";
      if (urlStr.match(/(http)|(file)/i)) {
        clientBridge.callBridge({
          name: "openNewNative",
          params: {"url": urlStr},
          successCallback: function () {
            tempUrl = urlStr.split("#");
            tempUrl[0] = tempUrl[0] + (tempUrl[0].match(/\?/) ? "&" : "?") + "openType=newNative";
            urlStr = tempUrl.length > 1 ? tempUrl.join("#") : tempUrl[0];
            setTimeout(() => {
              window.location.href = tempUrl;
            }, 100);
          },
          failCallback: function () {
            var href = location.href;
            tempUrl = (href.match(/\?/) ? href.split("?")[0] : href.split("#")[0]);
            if (urlStr.indexOf("&") == 0) {
              urlStr = urlStr.replace("&", "");
              tempUrl += "?";
            }
            setTimeout(() => {
              window.location.href = tempUrl + '#/' + urlStr;
            }, 100);
          }
        })
      } else {
        var href = location.href;
        tempUrl = (href.match(/\?/) ? href.split("?")[0] : href.split("#")[0]);
        if (urlStr.indexOf("&") == 0) {
          urlStr = urlStr.replace("&", "");
          tempUrl += "?";
        }
        clientBridge.callBridge({
          name: "openNewNative",
          params: {"url": tempUrl + urlStr},
          successCallback: function () {
            setTimeout(function () {
              window.location.href = tempUrl + (tempUrl.match(/\?/) ? "" : "?") + "openType=newNative"
                + (urlStr.split("#")[0] == "" ? "" : "&") + urlStr;
            }, 100);
          },
          failCallback: function () {
            setTimeout(function () {
              window.location.href = tempUrl + '#/' + urlStr;
            }, 100);
          }
        })
      }
    };
    /**
     * 关闭当前webview
     */
    Vue.prototype.finishWebAct = function (successHandle, failureHandle) {
      clientBridge.callBridge ({
        name: "finishWebAct",
        params: {},
        successCallback: function () {
          successHandle && successHandle()
        },
        failCallback: function () {
          failureHandle && failureHandle();
          sessionStorage.setItem('needGoBack',true)
        }
      });
    };
  }
}
